import { IonCol, IonImg, IonRow, IonText } from '@ionic/react';

import QuickLinkBg from '@/assets/bg-pattern-grid.png';

import styles from './CategoryHeader.module.css';

import { Button } from '../Button';

interface CategoryHeaderProps {
  title: string;
  message?: string;
  buttonText?: string;
  buttonAction?: () => void;
}

export const CategoryHeader = ({ title, message, buttonText, buttonAction }: CategoryHeaderProps) => {
  return (
    <div className={styles.wrapper}>
      <IonRow className='ion-justify-content-between'>
        <IonCol className={styles.text}>
          <IonText className={styles.heading}>{title}</IonText>
          <IonText className={styles.message}>{message}</IonText>
        </IonCol>
        {buttonText && buttonAction && (
          <IonCol className={styles.button} size='auto'>
            <Button onClick={buttonAction} size='medium' variant='primary'>
              {buttonText}
            </Button>
          </IonCol>
        )}
      </IonRow>
      <IonImg className={styles.background} src={QuickLinkBg} />
    </div>
  );
};
